import * as React from 'react';
import SingleLogo from '@UI/SingleLogo';
import './LoadingScreen.css';

export default function LoadingScreen() {
  return (
    <div
      className="container"
      style={{ alignItems: 'center', justifyContent: 'center' }}
    >
      <SingleLogo className="logoLoading" />

      <svg
        className="spinner"
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M60 10 A50 50 0 0 1 110 60"
          stroke="url(#loader-gradient)"
          strokeWidth="4"
          strokeLinecap="round"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 60 60"
            to="360 60 60"
            dur="1.6s"
            repeatCount="indefinite"
          />
        </path>
        <defs>
          <linearGradient
            id="loader-gradient"
            x1="60"
            y1="10"
            x2="60"
            y2="50"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#2aabdf" stopOpacity="0" />
            <stop offset="100%" stopColor="#2aabdf" stopOpacity="1" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}
